<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.amzReplenishmentNo || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ formData.amzPeriodTitle || '' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          size="mini"
          :type="
            formData.replenishmentStatus === 'N'
              ? 'primary'
              : formData.replenishmentStatus === 'D'
              ? 'danger'
              : formData.replenishmentStatus === 'P'
              ? 'warning'
              : formData.replenishmentStatus === 'Y'
              ? 'success'
              : formData.replenishmentStatus === 'S'
              ? 'logistics'
              : 'info'
          "
        >
          {{ formData.v_replenishmentStatus }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          v-if="formData.v_skuSalesChannel"
          size="mini"
          :type="
            formData.skuSalesChannel === 'F'
              ? 'success'
              : formData.skuSalesChannel === 'V'
              ? 'warning'
              : ''
          "
        >
          {{ formData.v_skuSalesChannel }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ $l('table_label_confirmReplyTotalCtnCbm') || '已确认总箱体积' }}：
        </span>
        <span style="font-size: 14px; color: #409EFF">
          {{ `${format(confirmReplyTotalCtnCbm) || '0'}(m³)` }}
        </span>
      </div>
    </div>
    <SkuTable
      :amzReplenishmentCode="amzReplenishmentCode"
      :disabled="disabled"
      :isVc="isVc"
      @reload="getConfirmReplyTotalCtnCbm"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
import SkuTable from '../sku-table'
export default {
  mixins: [EditLoading],
  components: { SkuTable },
  props: {
    amzReplenishmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return { formData: {}, confirmReplyTotalCtnCbm: 0, format }
  },
  computed: {
    isVc() {
      const { skuSalesChannel } = this.formData
      return skuSalesChannel == 'V' ? 'Y' : 'N'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      if (!this.amzReplenishmentCode) return
      const params = { amzReplenishmentCode: this.amzReplenishmentCode }
      const res = await this.$api
        .ecomAmzReplenishmentDetailApi(params)
        .catch(() => null)
      this.formData = res?.body || {}
    },
    async getConfirmReplyTotalCtnCbm() {
      if (!this.amzReplenishmentCode) return
      const res = await this.$api
        .ecomAmzReplenishmentConfirmReplyTotalCtnCbmApi(
          this.amzReplenishmentCode
        )
        .catch(() => null)
      this.confirmReplyTotalCtnCbm = res?.body || 0
    },
    async confirm() {
      const confirm = await this.$confirm(
        this.$l('tips_confirmReplenishment') || '是否确认补货？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzReplenishmentConfirmReplenishmentApi({
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_confirmSuccess') || '确认成功！',
        type: 'success',
      })

      const { amzReplenishmentCode, amzReplenishmentNo } = this.formData
      await this.closeCurPage()
      this.$router.push({
        name: 'ecom-awsBiz-replenishmentList-detail',
        params: { code: amzReplenishmentCode, pageType: 'detail' },
        query: { amzReplenishmentNo },
      })
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
::v-deep {
  .el-tag--logistics {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
